import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { schema } from '@techstyle/redux-core';
export var FeatureErrorType = {
  NOT_FOUND: 'NOT_FOUND',
  OTHER: 'OTHER'
};
export var Feature = new schema.Entity('Feature', {}, {
  idAttribute: 'handle',

  processStrategy(input, parent, key) {
    var valueType = input.valueType,
        value = input.value,
        rest = _objectWithoutProperties(input, ["valueType", "value"]);

    var parsedValue = valueType === 'json' ? JSON.parse(value) : value;
    return _objectSpread(_objectSpread({}, rest), {}, {
      valueType,
      value: parsedValue
    });
  }

});